module.exports = __webpack_public_path__ + "img/2-find.cadb645a.svg";